import { Menu } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { IconMessage } from "@tabler/icons-react";
import { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import { type IComment } from "src/pages/Summary/Summary.types";
import { useDispatch, useSelector } from "src/redux/hooks";
import { setComments } from "src/redux/slices/verifySlice";

import CommentsModal from "../CommentsModal/CommentsModal";

const VerifyCommentsButton = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const { idType, lbeidOrPartId } = useParams();
  const comments = useSelector(state => state.verifySlice.comments);
  const dispatch = useDispatch();

  const handleSetComments = useCallback(
    (res: IComment[]) => {
      dispatch(setComments(res));
    },
    [dispatch],
  );

  const id = { [String(idType)]: lbeidOrPartId };
  return (
    <>
      <Menu.Item leftSection={<IconMessage size={20} />} onClick={open}>
        Comments
      </Menu.Item>
      <CommentsModal
        opened={opened}
        onClose={close}
        {...id}
        comments={comments}
        type="editable"
        setReviewComments={handleSetComments}
      />
    </>
  );
};

export default VerifyCommentsButton;
